const listModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/common/list-modal/list-modal.html',
  controller: 'ListModalController',
};

angular
  .module('pis-common.module')
  .component('listModal', listModal);
